import React from "react";

const ContactSection = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Contact Us</h2>
            </div>
          </div>
        </div>
      </div>


      <section className="contact-section">
        <div className="container">

          {/* Contact Info */}
          <div className="contact-info-area">
            <div className="row">

              {/* Phone */}
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="single-contact-info flex-fill">
                  <span>
                    <i className="fas fa-phone-alt"></i>
                  </span>
                  <h3>Phone Number</h3>
                  <a href="tel:+919892544084" className="text-white">+91 9892544084</a>
                </div>
              </div>

              {/* Email */}
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="single-contact-info flex-fill">
                  <span>
                    <i className="fas fa-envelope"></i>
                  </span>
                  <h3>Email Address</h3>
                  <a href="mailto:booking@omshreecabs.com" className="text-white">
                    booking@omshreecabs.com
                  </a>
                </div>
              </div>

              {/* Location */}
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="single-contact-info flex-fill">
                  <span>
                    <i className="fas fa-map-marker-alt"></i>
                  </span>
                  <h3>Location</h3>
                  <p>Omshree Cabs</p>
                  <p>
                   Shri Omkar Co-op Housing Society,
E-11/101, Sector 9,
Ghansoli (Gharonda),
Navi Mumbai, Maharashtra, India - 400701
                  </p>
                </div>
              </div>

            </div>
          </div>





<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2704.6255775137706!2d72.99501207520635!3d19.117013382095998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDA3JzAxLjMiTiA3MsKwNTknNTEuMyJF!5e1!3m2!1sen!2sin!4v1777462531867!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

          {/* Contact Form */}
        

        </div>
      </section>
    </>
  );
};

export default ContactSection;